import { BarFullSVG } from "./components/BarFullSVG";
import { BoxPlot } from "./components/BoxPlot";
import { BoundaryBar } from "./components/BoundaryBar";
import "./App.css";

function App() {
  // Beispielwerte für Development (0-4 Bereich)
  const markerPercent = 2.8;
  const markerPercent2 = 1.6;
  const quartileRangeX = 0.3;
  const quartileRangeWidth = 2.6;
  const quartileMainX = 1.19;
  const quartileMainWidth = 0.4;

  return (
    <div>
      <h1>Mini Planetary Boundaries Diagramm</h1>
      <BarFullSVG />
      <BoxPlot
        markerPercent={markerPercent}
        quartileRangeX={quartileRangeX}
        quartileRangeWidth={quartileRangeWidth}
        quartileMainX={quartileMainX}
        quartileMainWidth={quartileMainWidth}
      />
      <div style={{ height: "30px" }}></div>
      <BoundaryBar
        markerPercent={markerPercent2}
        name="Freshwater Change"
        nameLabel="Test"
        showLeftArrows={false}
        showRightArrows={true}
      />
      <div style={{ height: "30px" }}></div>
      <BoundaryBar
        markerPercent={markerPercent2}
        name="Both arrow"
        showLeftArrows={true}
        showRightArrows={true}
      />
      <div style={{ height: "30px" }}></div>
      <BoundaryBar
        markerPercent={markerPercent2}
        name="Left Arrow"
        showLeftArrows={true}
      />
      <div style={{ height: "30px" }}></div>
      <BoundaryBar
        markerPercent={markerPercent2}
        name="Freshwater Change"
        showRightArrows={true}
      />
      <div style={{ height: "30px" }}></div>
      <BoundaryBar
        markerPercent={markerPercent2}
        name="Dotted Line"
        dottedLine={[0, 3.2]}
      />
    </div>
  );
}

export default App;
